import { AutogenLayoutDrsPayeeList } from "./autogen/AutogenLayoutDrsPayeeList";
import { UrlUtil } from "@mcleod/core";

export class DrsPayeeList extends AutogenLayoutDrsPayeeList {
    onLoad(): void | Promise<void> {
        const urlProp = UrlUtil.getPropsFromUrl(window.location.search);
        if (urlProp != null && urlProp.ids != null) {
            this.mainDataSource.search({ ids: urlProp.ids });
        }
    }
}
